package main.kotlin.app.foodees.web.icons

import main.kotlin.app.foodees.web.components.atoms.icon.mSvgIcon
import main.kotlin.app.foodees.web.components.atoms.icon.path
import react.*

fun RBuilder.mDirectionsIcon() {
    mSvgIcon("directions") {
        path(d = "M21.71 11.29l-9-9c-.39-.39-1.02-.39-1.41 0l-9 9c-.39.39-.39 1.02 0 1.41l9 9c.39.39 1.02.39 1.41 0l9-9c.39-.38.39-1.01 0-1.41zM14 14.5V12h-4v3H8v-4c0-.55.45-1 1-1h5V7.5l3.5 3.5-3.5 3.5z") {}
        path(d = "M0 0h24v24H0z", fill = "none") {}

    }
}
